module.exports = __webpack_public_path__ + "img/error.e68374f2.png";